import { faEnvelope, faLock } from "@fortawesome/pro-light-svg-icons"
import {
  Button,
  CalloutBox,
  createErrorFromResponse,
  FlexBox,
  JoonUIColor,
  Shadow,
  SPACING,
  TextInput,
  Typography,
} from "@joonapp/web-shared"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import GoogleAuth from "./GoogleAuth"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import useDocumentTitle from "../../hooks/usePageTitle"
import { signin } from "../../networking/authentication/api"
import { FormAlert } from "../../types"
import { sessionManager } from "../../util/storage"

const SignIn = () => {
  useDocumentTitle("Joon - Sign In")
  const [formAlert, setFormAlert] = useState<FormAlert | null>(null)
  const [pending, setPending] = useState(false)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const navigate = useNavigate()

  useEffect(() => {
    if (sessionManager.getRefreshToken()) navigate("/patients")
  }, [navigate])

  const hasFormError = (response: any) => {
    const errorMessage = response.error ?? response.data?.error
    if (errorMessage) {
      setPending(false)
      setFormAlert({ type: "error", message: errorMessage })
      return true
    } else {
      setFormAlert(null)
      return false
    }
  }

  const signIn = (e: React.FormEvent) => {
    setPending(true)
    e.preventDefault()
    signin(email, password)
      .then((response: any) => {
        if (hasFormError(response)) return

        sessionManager.storeTokens(
          response.data.refresh_token,
          response.data.id_token
        )
        setPending(false)
        navigate("/")
      })
      .catch((err) => {
        const errorMessage = createErrorFromResponse(err)
        if (errorMessage) setFormAlert({ type: "error", message: errorMessage })
        setPending(false)
      })
  }

  return (
    <PageWrapper
      style={{
        background: JoonUIColor.background.xlightGray,
        justifyContent: "center",
        alignItems: "center",
        gap: SPACING.space6,
      }}
    >
      <img
        src="/images/logos/JoonCoach.svg"
        alt="Joon Coach Logo"
        style={{ height: "30px" }}
      />
      <FlexBox
        direction="column"
        gap={SPACING.space6}
        align="center"
        style={{
          width: "min(400px, 95vw)",
          border: `1px solid ${JoonUIColor.border.default}`,
          padding: SPACING.space10,
          borderRadius: SPACING.space4,
          background: JoonUIColor.background.primaryNeutral,
          boxShadow: Shadow.high,
        }}
      >
        <Typography variant="h3">Sign In</Typography>
        {formAlert && (
          <CalloutBox type={formAlert.type}>{formAlert.message}</CalloutBox>
        )}

        <form onSubmit={signIn} style={{ width: "100%" }}>
          <FlexBox gap={SPACING.space4} direction="column">
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="body">Email</Typography>
              <TextInput
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                icon={faEnvelope}
                fullWidth={true}
              />
            </FlexBox>

            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="body">Password</Typography>
              <TextInput
                type="password"
                icon={faLock}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="pass"
                fullWidth={true}
              />
            </FlexBox>

            <Button
              isLoading={pending}
              text="Sign In"
              fullWidth
              type="submit"
              style={{ marginTop: SPACING.space2 }}
            />
          </FlexBox>
        </form>
        <GoogleAuth />
      </FlexBox>
    </PageWrapper>
  )
}

export default SignIn
